import { Card, Layout, Typography } from "antd";
import React from "react";
import "./App.css";
import DynamicCarousel from "./components/DynamicCarousel";

const { Header, Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const jokesContent = {
  title: "React Giggles",
  content: [
    {
      textToDisplay:
        "Why did the React developer break up with their partner? Because they didn’t have enough props!",
      imageSrc: "/images/joke1.png",
    },
    {
      textToDisplay:
        "Why did the React component go to therapy? It had too much state to manage!",
      imageSrc: "/images/joke2.png",
    },
    {
      textToDisplay:
        "What’s a React developer’s favorite exercise? Component mount-ain climbers!",
      imageSrc: "/images/joke3.png",
    },
  ],
};

const educationContent = [
  {
    title: "Introduction to React",
    content:
      "React is an innovative JavaScript library developed by Facebook, designed to help developers create highly dynamic and interactive user interfaces with ease. By leveraging a virtual DOM, React ensures efficient updates to the user interface, making it ideal for complex applications. With its declarative syntax and component-based structure, React has become one of the most popular tools for building modern web applications.",
  },
  {
    title: "Key Concepts in React",
    content:
      "React components serve as the foundational building blocks, encapsulating UI elements and their behavior for modular and maintainable code. Props and state enable powerful data management within and between components, ensuring your application stays organized and responsive. Additionally, hooks like useState and useEffect have revolutionized how developers manage state and lifecycle events in functional components, making React development even more efficient and intuitive.",
  },
  {
    title: "React in Action",
    content:
      "Global tech giants like Facebook, Instagram, and Netflix rely on React to deliver seamless and engaging user experiences. Developers leverage React’s ecosystem, which includes tools like Redux for state management, React Router for navigation, and libraries such as Material-UI and Ant Design for pre-built UI components. By combining React with these tools, developers can create scalable, fast, and aesthetically pleasing applications for the web and mobile platforms.",
  },
  {
    title: "Why Choose React?",
    content:
      "React stands out due to its vast community support, extensive documentation, and flexibility. Its ability to integrate with other libraries and frameworks makes it a versatile choice for developers across industries. Whether you're building single-page applications (SPAs), progressive web applications (PWAs), or even mobile apps with React Native, the possibilities with React are virtually limitless. Its component reusability and focus on performance optimization make it a go-to choice for developers worldwide.",
  },
  {
    title: "Getting Started with React",
    content:
      "To begin your journey with React, start by understanding its core concepts like JSX, components, props, and state. Gradually explore advanced topics such as context API, hooks, and server-side rendering. Setting up a project using Create React App or Vite ensures a hassle-free development environment. Dive into building projects, such as a to-do list or a portfolio website, to gain hands-on experience with React’s capabilities.",
  },
];

const App = () => {
  return (
    <Layout style={{ minHeight: "100vh", backgroundColor: "#f0f4f8" }}>
      <Header
        style={{
          background: "linear-gradient(to right, #6a11cb, #2575fc)",
          color: "#ffffff",
          textAlign: "center",
          fontSize: "36px",
          fontWeight: "bold",
          lineHeight: "64px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        Why State Serious? Let’s React!
      </Header>
      <Content
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px",
          background: "linear-gradient(to bottom, #e0f7fa, #b2ebf2, #80deea)",
        }}
      >
        <Card
          style={{
            width: "80%",
            maxWidth: "800px",
            borderRadius: "15px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
            marginBottom: "40px",
          }}
        >
          <DynamicCarousel
            title={jokesContent.title}
            content={jokesContent.content}
          />
        </Card>

        <div style={{ width: "80%", maxWidth: "800px" }}>
          {educationContent.map((section, index) => (
            <Card
              key={index}
              style={{
                marginBottom: "20px",
                borderRadius: "10px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                padding: "20px",
                background: "#ffffff",
              }}
            >
              <Title level={3} style={{ color: "#2575fc" }}>
                {section.title}
              </Title>
              <Paragraph style={{ color: "#4f4f4f" }}>
                {section.content}
              </Paragraph>
            </Card>
          ))}
        </div>
      </Content>
      <Footer
        style={{
          textAlign: "center",
          background: "linear-gradient(to right, #2575fc, #6a11cb)",
          color: "#ffffff",
          padding: "20px",
          fontSize: "16px",
        }}
      >
        Made with 💙 using React |{" "}
        <a
          href="https://react.dev"
          style={{ color: "#48cae4", textDecoration: "none" }}
        >
          Learn React
        </a>
      </Footer>
    </Layout>
  );
};

export default App;
